import React from 'react';

import PropTypes from 'prop-types';

import { Title } from '@asteria/component-core/typography';

import { ListCell, ListGroup, ListHeader } from '@asteria/component-list';

import { Translation } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import SectionRow from './row';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { section: unknown, first?: boolean }> } */
const Section = function Section(props) {
	const { section, query, links, first } = props;

	return (
		<ListGroup>
			<ListHeader className={cn({ 'mt-2': !first })}>
				<ListCell>
					<Translation
						translationKey={[
							'transaction.details.header',
							`transaction.details.header.${section.type}`,
						]}
						data={{
							item: query?.data,
							...links,
							bank: links.bankTransaction,
						}}
						Component={Title}
					/>
				</ListCell>
			</ListHeader>
			{section.children.map((object) => (
				<SectionRow key={object.key} {...props} object={object} />
			))}
		</ListGroup>
	);
};

Section.propTypes = {
	section: PropTypes.object,
	query: PropTypes.object,
	links: PropTypes.object,
	first: PropTypes.bool,
};

export default Section;
